import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FiMenu, FiX, FiInstagram, FiYoutube } from "react-icons/fi";
import { FaSpotify, FaTiktok } from "react-icons/fa";
import { CiMenuFries } from "react-icons/ci";

const NavbarMusic = () => {
  const [open, setOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);

    if (el) {
      const yOffset = -80; // tinggi navbar
      const y = el.getBoundingClientRect().top + window.scrollY + yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }

    setOpen(false); // auto close mobile
  };

  return (
    <header className="w-full fixed top-0 left-0 z-50">
      {/* ================= MAIN NAVBAR ================= */}
      <div className="bg-black/70 backdrop-blur-md text-white">
        <div className="px-4 md:px-6 lg:px-10 h-[74px] flex items-center justify-between">
          {/* LOGO */}
          <NavLink to="/" className="flex items-center gap-3">
            <img src="/images/logo.png" alt="Kalia Siska" className="h-12 object-contain" />
            <div>
              <p className="text-lg font-semibold leading-none">Kalia Siska</p>
              <p className="text-xs text-gray-300">Official Music</p>
            </div>
          </NavLink>

          {/* MENU DESKTOP */}
          <nav className="hidden lg:flex items-center gap-8 font-medium">
            <nav className="hidden lg:flex items-center gap-8 font-medium">
              <button onClick={() => scrollToSection("beranda")} className="hover:text-pink-400">
                Beranda
              </button>
              <button onClick={() => scrollToSection("informasi")} className="hover:text-pink-400">
                Informasi
              </button>
              {/* <button onClick={() => scrollToSection("agenda")} className="hover:text-pink-400">
                Agenda
              </button> */}
              <button onClick={() => scrollToSection("music")} className="hover:text-pink-400">
                Explore Music
              </button>
              <button onClick={() => scrollToSection("galeri")} className="hover:text-pink-400">
                Galeri
              </button>
              <button onClick={() => scrollToSection("kontak")} className="hover:text-pink-400">
                Kontak
              </button>
            </nav>
          </nav>

          {/* RIGHT SIDE */}
          <div className="hidden lg:flex items-center gap-4">
            {/* SOCIAL ICON */}
            <Link to="https://open.spotify.com/artist/70hsEvlt6YZPT97UIvzpEu" className="hover:text-green-400" target="_blank">
              <FaSpotify size={20} />
            </Link>
            <Link to="https://www.instagram.com/kaliasiska86/" className="hover:text-pink-400" target="_blank">
              <FiInstagram size={20} />
            </Link>
            <Link to="https://www.youtube.com/results?search_query=kalia+siska+official" target="_blank" className="hover:text-red-500">
              <FiYoutube size={20} />
            </Link>
            <Link to="https://www.tiktok.com/@kaliasiska_" target="_blank" className="hover:text-gray-700">
              <FaTiktok size={18} />
            </Link>

            {/* CTA */}
            <NavLink to="/explore" className="bg-pink-500 hover:bg-pink-600 px-5 py-2 rounded-full font-semibold transition">
              Listen Now
            </NavLink>
          </div>

          {/* HAMBURGER */}
          <button className="lg:hidden" onClick={() => setOpen(!open)}>
            {open ? <FiX size={28} /> : <CiMenuFries size={28} />}
          </button>
        </div>
      </div>

      {/* ================= MOBILE MENU ================= */}
      <div className={`lg:hidden fixed top-[74px] left-0 w-full bg-black text-white transition-all duration-300 ${open ? "max-h-screen py-6" : "max-h-0 overflow-hidden"}`}>
        <div className="flex flex-col items-center gap-6 font-medium">
          <button onClick={() => scrollToSection("beranda")}>Beranda</button>
          <button onClick={() => scrollToSection("informasi")}>Informasi</button>
          {/* <button onClick={() => scrollToSection("agenda")}>Agenda</button> */}
          <button onClick={() => scrollToSection("music")}>Explore Music</button>
          <button onClick={() => scrollToSection("galeri")}>Galeri</button>
          <button onClick={() => scrollToSection("kontak")}>Kontak</button>

          {/* SOCIAL */}
          <div className="flex gap-5 mt-4">
            <Link to={"https://open.spotify.com/artist/70hsEvlt6YZPT97UIvzpEu"} target="_blank">
              <FaSpotify size={22} />
            </Link>

            <Link to={"https://www.instagram.com/kaliasiska86/"} target="_blank">
              <FiInstagram size={22} />
            </Link>

            <Link to={"https://www.youtube.com/results?search_query=kalia+siska+official"} target="_blank">
              <FiYoutube size={22} />
            </Link>

            <Link to={"https://www.tiktok.com/@kaliasiska_"} target="_blank">
              <FaTiktok size={22} />
            </Link>
          </div>

          {/* CTA */}
          <NavLink to="/explore" className="bg-pink-500 px-6 py-2 rounded-full mt-4" onClick={() => setOpen(false)}>
            Listen Now
          </NavLink>
        </div>
      </div>
    </header>
  );
};

export default NavbarMusic;
